<template>
    <div class="game-frame-container">
        <div v-if="!session" class="no-session">
            <p>No active game session</p>
        </div>
        <div v-else-if="session.launch_url" class="iframe-wrapper">
            <div v-show="iframeLoading" class="iframe-loading-overlay" aria-hidden="true">
                <div class="iframe-loading-spinner"></div>
                <p class="iframe-loading-text">Loading game...</p>
            </div>
            <iframe
                :src="session.launch_url"
                :key="session.launch_url"
                class="game-iframe"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                @load="onIframeLoad"
            ></iframe>
        </div>
        <div v-else class="loading-session">
            <div class="spinner"></div>
            <p>Loading game session...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SlotsGameFrame',
    props: {
        session: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            iframeLoading: true
        };
    },
    watch: {
        'session.launch_url'() {
            this.iframeLoading = true;
        }
    },
    methods: {
        onIframeLoad() {
            this.iframeLoading = false;
        }
    }
};
</script>

<style scoped>
.game-frame-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no-session {
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    padding: 24px;
}

.loading-session {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 24px;
}

.spinner {
    width: 48px;
    height: 48px;
    border: 3px solid rgba(255, 255, 255, 0.12);
    border-top-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.loading-session p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    font-weight: 500;
    margin: 0;
}

.iframe-wrapper {
    width: 100%;
    height: 100%;
    min-height: 320px;
    position: relative;
    background: #0d0f1a;
}

.iframe-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background: #0d0f1a;
    z-index: 1;
    transition: opacity 0.3s ease;
}

.iframe-loading-spinner {
    width: 48px;
    height: 48px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top-color: var(--color-copper, #d4a574);
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}

.iframe-loading-text {
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;
    font-weight: 500;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    letter-spacing: 0.02em;
}

.game-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    background: #0d0f1a;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
    .loading-session p {
        font-size: 14px;
    }

    .spinner {
        width: 40px;
        height: 40px;
        border-width: 3px;
    }
}

@media (max-width: 480px) {
    .loading-session p {
        font-size: 13px;
    }

    .spinner {
        width: 35px;
        height: 35px;
    }

    .no-session p {
        font-size: 14px;
    }
}
</style>
